/* eslint-disable */
import React, { useRef } from 'react'
import * as THREE from 'three'

import 'react-three-fiber'

function BaseLine({ side = 'l', dist = 300, position = [0, 0, 3] }) {
    const mesh = useRef()
    const geometry = new THREE.CylinderGeometry(1, 1, 90, 8)
    const material = new THREE.MeshBasicMaterial({ color: 0xaaaa00 })

    let v
    let vOffset
    const offset = 1.5

    if (side === 'l') {
        v = new THREE.Vector3(-1, 1, 0).normalize().multiplyScalar(dist)
        vOffset = new THREE.Vector3(-1, -1, 0)
            .normalize()
            .multiplyScalar(offset)
    } else {
        v = new THREE.Vector3(1, 1, 0).normalize().multiplyScalar(dist)
        vOffset = new THREE.Vector3(1, -1, 0).normalize().multiplyScalar(offset)
    }
    v.add(vOffset)

    return (
        <mesh
            ref={mesh}
            rotation={[-0.5 * Math.PI, 0, 0]}
            name={side === 'l' ? 'left_baseline' : 'right_baseline'}
            position={[v.x + position[0], v.y, 45]}
            geometry={geometry}
            material={material}
        />
    )
}

export default BaseLine
